<form *ngIf="inactivateForm" [formGroup]="inactivateForm">
  <div class="column">
    <div class="row inactive-property-form">
      <div class="row inactive-property-header">
        <div class="column"><span class="row"><mat-icon>warning</mat-icon>&nbsp; Inactivate property info</span></div>
        <div class="column"><span class="row"><a (click)="openPropertyDetailModal()">PROPERTY DETAIL</a></span></div>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Reason to inactivate the property</mat-label>
          <mat-select formControlName="reason" placeholder="Reason">
            <mat-option *ngFor="let reason of reasons" [value]="reason" (onSelectionChange)="reasonChanged($event)">{{ reason }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Contract file</mat-label>
          <input type="file" formControlName="contractFile" required>
        </mat-form-field>
        <mat-form-field appearance="outline" class="column">
          <mat-label>Last date short-term rentals to remit</mat-label>
          <input [matDatepicker]="lastRentedPicker" formControlName="lastRented" matInput required>
          <mat-datepicker-toggle [for]="lastRentedPicker" matIconSuffix></mat-datepicker-toggle>
          <mat-datepicker #lastRentedPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
